import styles from './DiscoverStory.module.css'

const DiscoverStory = ({ image }) => {
  return (
    <section className={styles.discoverStory} id="about">
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.titleSection}>
            <h2 className={styles.title}>Discover Our Story</h2>
            <p className={styles.subtitle}>A Tradition of Excellence and Innovation</p>
          </div>
          <div className={styles.description}>
            <p>
              Established in 2012, Nikket Engineering Works comprises of an integrated team of Engineers & Technicians with 14+ Years of Experience in various aspects of HVAC Industry namely – Design, Estimation, Execution, Operation, Sales, after Sales Service & Maintenance.
            </p>
          </div>
        </div>

        <div className={styles.imageWrapper}>
          {image ? (
            <img src={image} alt="Nikket Engineering Works Team" className={styles.image} />
          ) : (
            <div className={styles.imagePlaceholder}>
              <span>Team Image</span>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default DiscoverStory
